import React, { useState, useEffect } from "react";
import { Button, Row, Col } from "react-bootstrap";
import "./index.scss";

import QuantityInput from "../../QuantityInput";
import { DetailsCartIcon } from "../../../assets/icons/DetailsCartIcon";
import { CheckIcon } from "../../../assets/icons/CheckIcon";
import { ActiveCleeSection } from "../ActifsClee";
import { useCart } from "../../../context/CartContext";
import { toast } from "react-toastify";

const ProductSection = ({ product }) => {
  const [error, setError] = useState("");
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const [mainImage, setMainImage] = useState("");
  const { addToCart } = useCart();

  // Debug: Log the product data
  console.log("ProductSection - product:", product);
  console.log("ProductSection - bienfaits:", product?.bienfaits);

  // Process bienfaits data to handle JSON string format
  const processBienfaits = (bienfaitsData) => {
    if (!bienfaitsData) return [];
    
    console.log("Raw bienfaits data:", bienfaitsData);
    console.log("Type:", typeof bienfaitsData);
    console.log("Is Array:", Array.isArray(bienfaitsData));
    
    let bienfaitsArray = [];
    
    if (Array.isArray(bienfaitsData)) {
      // Check if it's an array containing a single JSON string
      if (bienfaitsData.length === 1 && typeof bienfaitsData[0] === 'string') {
        const firstItem = bienfaitsData[0];
        console.log("Single string item:", firstItem);
        
        // Check if it's a JSON array string
        if (firstItem.startsWith('[') && firstItem.endsWith(']')) {
          try {
            const parsed = JSON.parse(firstItem);
            console.log("Parsed JSON array:", parsed);
            if (Array.isArray(parsed)) {
              bienfaitsArray = parsed;
            } else {
              // If parsing fails, treat as comma-separated string
              bienfaitsArray = firstItem.split(',').map(item => item.trim());
            }
          } catch (e) {
            console.log("JSON parse failed, treating as comma-separated");
            // If parsing fails, treat as comma-separated string
            bienfaitsArray = firstItem.split(',').map(item => item.trim());
          }
        } else {
          // Regular string, split by comma
          bienfaitsArray = firstItem.split(',').map(item => item.trim());
        }
      } else {
        // Normal array with multiple items
        bienfaitsArray = bienfaitsData;
      }
    } else if (typeof bienfaitsData === 'string') {
      // If it's a string, try to parse it or split it
      try {
        const parsed = JSON.parse(bienfaitsData);
        if (Array.isArray(parsed)) {
          bienfaitsArray = parsed;
        } else {
          // If not a JSON array, split by comma
          bienfaitsArray = bienfaitsData.split(',').map(item => item.trim());
        }
      } catch (e) {
        // If JSON parsing fails, split by comma
        bienfaitsArray = bienfaitsData.split(',').map(item => item.trim());
      }
    }
    
    console.log("Processed bienfaits array:", bienfaitsArray);
    return bienfaitsArray;
  };

  const processedBienfaits = processBienfaits(product?.bienfaits);

  // Images
  const imageUrls =
    product?.listeImage?.map(
      (img, index) =>
        `https://api.almasecret.msit-demo.fr/products/${product?._id}/listeImage/${index}`
    ) || [];

  useEffect(() => {
    if (imageUrls.length > 0) setMainImage(imageUrls[0]);
  }, [product]);

  if (!product) return null;

  // ✅ Vérification promo active selon dates
  const now = new Date();
  const promoStart = product?.promoStartDate
    ? new Date(product.promoStartDate)
    : null;
  const promoEnd = product?.promoEndDate
    ? new Date(product.promoEndDate)
    : null;
  const isPromoActive =
    product?.isOnPromo &&
    promoStart &&
    promoEnd &&
    now >= promoStart &&
    now <= promoEnd;

  // 💰 Calcul du prix final
  const ttc = parseFloat(product?.ttc || 0);
  const pourcentagePromo = parseFloat(product?.pourcentagePromo || 0);
  const prixFinal = isPromoActive
    ? parseFloat((ttc - (ttc * pourcentagePromo) / 100).toFixed(3))
    : ttc;

  // 🛒 Ajout panier
  const handleAddToCart = () => {
    if (selectedQuantity <= 0) {
      setError("Veuillez choisir une quantité valide.");
      return;
    }
    if (selectedQuantity > product.quantite) {
      setError("Quantité demandée supérieure au stock disponible !");
      return;
    }

    setError("");

    const productToAdd = {
      _id: product._id,
      title: product.title,
      price: prixFinal,
      quantity: selectedQuantity,
      quantite: product.quantite, // stock max
      image: imageUrls[0],
    };

    addToCart(productToAdd);
  };

  return (
    <>
      <section className="product-section container my-5">
        <Row className="mx-0 gx-0">
          {/* Images produit */}
          <Col md={6} className="product-images">
            <div className="main-image-container">
              <div className="main-image">
                <img
                  src={mainImage}
                  alt={product?.title || "Produit"}
                  className="img-fluid"
                />
              </div>
              <div className="category-overlay">{product?.categoryId?.title}</div>
            </div>

            <div className="thumbnails">
              {imageUrls.map((url, index) => (
                <img
                  key={index}
                  src={url}
                  alt={`thumb-${index}`}
                  className={`thumbnail-img ${
                    mainImage === url ? "active" : ""
                  }`}
                  onClick={() => setMainImage(url)}
                />
              ))}
            </div>
          </Col>

          {/* Détails produit */}
          <Col md={6} className="product-details ps-md-5 ps-0">
            <h2 className="title">{product?.title}</h2>

            <div className="rating">
              ★★★★☆ <span>4.5</span>
            </div>

            {isPromoActive ? (
              <div className="price">
                <span className="current">
                  {prixFinal} <span>DT</span>
                </span>
                <span className="old">{ttc.toFixed(3)} DT</span>
                <span className="discount">-{pourcentagePromo}%</span>
              </div>
            ) : (
              <div className="price">
                <span className="current">
                  {ttc.toFixed(3)} <span>DT</span>
                </span>
              </div>
            )}

            <div className="quantity-add d-flex align-items-center mt-3">
              {product.stockRupture || product.quantite == 0 ? (
                <QuantityInput
                  quantite={product?.quantite}
                  setError={setError}
                  onChange={setSelectedQuantity}
                  disabled={true}
                />
              ) : (
                <QuantityInput
                  quantite={product?.quantite}
                  setError={setError}
                  onChange={setSelectedQuantity}
                  disabled={false}
                />
              )}
              {product.stockRupture || product.quantite == 0 ? (
                <div className="repture ms-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none">
                    <path
                      d="M18.5 5.5L5.5 18.5"
                      stroke="#FF0000"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                      stroke="#FF0000"
                      stroke-width="1.5"
                    />
                  </svg>{" "}
                  Rupture de stock 
                </div>
              ) : (
                <Button className="ms-3 add-to-cart" onClick={handleAddToCart}>
                  <DetailsCartIcon />
                  AJOUTER AU PANIER
                </Button>
              )}
            </div>
            {error && <div className="error">{error}</div>}

            <p className="description mt-4">{product?.description}</p>

            <div className="benefits mt-4">
              <h5 className="mb-4">BIENFAITS</h5>
              <ul>
                {processedBienfaits && processedBienfaits.length > 0 ? (
                  processedBienfaits.map((benefit, index) => (
                    <li key={index}>
                      <CheckIcon /> {benefit.trim()}
                    </li>
                  ))
                ) : (
                  <li>Aucun bienfait disponible</li>
                )}
              </ul>
            </div>
          </Col>
        </Row>
      </section>

      <ActiveCleeSection product={product?.activeClee} id={product?._id} />
    </>
  );
};

export default ProductSection;
